export default {
  title: 'Articoli',
  order_note: 'Nota ordine',
};
